import React from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import { findDOMNode } from "react-dom";
class GeneralTd extends React.Component {
  render() {
    return (
      <td className={this.props.fieldClassName}>
        {this.props.fieldValue ? <span>{this.props.fieldValue}</span> : "-"}
        {this.props.noteValue && (
          <div style={{ width: "40px" }}>
            <p ref="foo" data-tip={this.props.noteValue}>
              <span
                style={{ width: "15px" }}
                className="material-icons indigo500 icon-in-row"
              >
                chat
              </span>
            </p>
            <ReactTooltip
              type="light"
              effect="solid"
              border={"true"}
            />
          </div>
        )}
      </td>
    );
  }
}

GeneralTd.propTypes = {
  fieldValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fieldClassName: PropTypes.string
};

export default GeneralTd;
